import { AxiosInstance } from "axios";
import { createLogger } from "logging";
import { EntityActionResult } from "models/EntityActionResult";

const logger = createLogger("RunParticipantApi");

export class RunParticipantApi {
  constructor(private axios: AxiosInstance) {}

  async addRunParticipant(runId: string, upn: string): Promise<EntityActionResult> {
    try {
      const response = await this.axios.put<EntityActionResult>(`/run-participants/${runId}/${upn}`);
      return response.data;
    } catch (error) {
      logger.error("Failed to add run participant", error);
      throw error;
    }
  }

  async deleteRunParticipant(runId: string, upn: string): Promise<EntityActionResult> {
    try {
      const response = await this.axios.delete<EntityActionResult>(`/run-participants/${runId}/${upn}`);
      return response.data;
    } catch (error) {
      logger.error("Failed to remove run participant", error);
      throw error;
    }
  }
}
